import React from 'react';
import { FeeInputType } from '@upstart/harmony/lib/legos/ricForm/ricFormTypes';
import { FinanceResponseData } from '@upstart/harmony/lib/legos/financingTypes';
import { getFinalizedFee } from '@upstart/harmony/lib/ric-form-utils';
import { FeeItem } from '../Components';

const SchemaFeeInput = ({
  formElement,
  responseData,
  fetchResponseWithUpdatedData,
  isSubSectionElement = false,
}: {
  formElement: FeeInputType;
  isSubSectionElement: boolean;
  responseData: FinanceResponseData;
  fetchResponseWithUpdatedData: (data: Partial<FinanceResponseData>) => void;
}) => {
  const { title, subtitle, required, feeType } = formElement;

  // Add 0 value fee if fee doesn't already exist in the financeResponse
  const fee = getFinalizedFee(responseData?.finalizedFeeList ?? [], feeType);

  return (
    <FeeItem
      title={title}
      subtitle={subtitle}
      fee={fee}
      responseData={responseData}
      onChange={fetchResponseWithUpdatedData}
      required={required}
      subsectionItem={isSubSectionElement}
    />
  );
};

export default SchemaFeeInput;
